// 基础语言数据（每种语言只定义一份）
const BASE_LANG_DATA = {
  zh_CN: {
    login_with_phone: '手机号登录',
    login_with_email: '邮箱登录',
    login_success: '登录成功',
    login_success_description: '你已成功登录game_name，请返回游戏查看',
    login_success_retry: '若游戏内未登录，请{retry_link}或{check_link}。',
    login_success_retry_scheme: '若未能返回应用，请{retry_link}。如仍有问题，可尝试{refresh_link}或{check_link}。',
    retry_link_text: '点此处重试',
    retry_open_app_link_text: '点击打开应用',
    refresh_page_link_text: '刷新页面',
    check_browser_link_text: '检查浏览器设置',
    browser_help_title: '如何检查浏览器设置：',
    browser_help_step1: '点击浏览器地址栏左侧的按钮；',
    browser_help_step2: '找到【本地网络访问权限】，并打开开关；',
    browser_help_step3: '刷新当前页面。',
    browser_help_chrome: 'Chrome 浏览器',
    browser_help_footer: '如上述步骤仍未解决，请尝试更换其他浏览器为默认浏览器。',
    login_cancel: '登录已取消',
    login_fail_invalid: '当前登录页面已失效，请返回game_name重试',
    enter_your_phone_number: '输入您的手机号码',
    enter_email: '输入您的邮箱',
    invalid_phone: '请输入有效的手机号码',
    invalid_email: '请输入有效的电子邮箱',
    incorrect_code: '请输入正确的验证码。',
    log_in: '登录',
    verify: '验证',
    retry: '重试',
    search: '搜索',
    phone_number: '手机号码',
    email: '电子邮箱',
    send_to: '发送至',
    enter_the_code: '输入验证码',
    send_a_code: '发送验证码',
    code_sent: '验证码已发送',
    fill_verification_code: '请填写验证码',
    user_agreement: '用户协议',
    privacy_policy: '隐私政策',
    tracking_id: '问题追踪码',
    copy: '复制',
    copied: '已复制',
  },
  zh_TW: {
    login_with_phone: '手機號登錄',
    login_with_email: '電子郵箱登入',
    login_success: '登入成功',
    login_success_description: '您已經成功登入game_name，請返回遊戲查看',
    login_success_retry: '若遊戲內未登入，請{retry_link}或{check_link}。',
    login_success_retry_scheme: '若未能返回應用，請{retry_link}。如仍有問題，可嘗試{refresh_link}或{check_link}。',
    retry_link_text: '點此處重試',
    retry_open_app_link_text: '點擊開啟應用',
    refresh_page_link_text: '重新整理頁面',
    check_browser_link_text: '檢查瀏覽器設定',
    browser_help_title: '如何檢查瀏覽器設定：',
    browser_help_step1: '點擊瀏覽器地址欄左側的按鈕；',
    browser_help_step2: '找到【區域網路存取權】，並打開開關；',
    browser_help_step3: '重新整理當前頁面。',
    browser_help_chrome: 'Chrome 瀏覽器',
    browser_help_footer: '如上述步驟仍未解決，請嘗試更換其他瀏覽器為預設瀏覽器。',
    login_cancel: '登入已取消',
    login_fail_invalid: '目前登錄頁面已失效，請回到game_name重試',
    enter_your_phone_number: '請輸入您的電話號碼',
    enter_email: '輸入您的電子郵件地址',
    invalid_phone: '請輸入有效的手機號碼',
    invalid_email: '請輸入有效的電子郵箱',
    incorrect_code: '請輸入正確的驗證碼',
    log_in: '登入',
    verify: '驗證',
    retry: '重試',
    search: '搜尋',
    phone_number: '手機號碼',
    email: '電子郵箱',
    send_to: '送信先',
    enter_the_code: '輸入驗證碼',
    send_a_code: '發送驗證碼',
    code_sent: '驗證碼已發送',
    fill_verification_code: '請填寫驗證碼',
    user_agreement: '用戶協議',
    privacy_policy: '隱私政策',
    tracking_id: '問題追蹤碼',
    copy: '複製',
    copied: '已複製',
  },
  en_US: {
    login_with_phone: 'Log in with Phone Number',
    login_with_email: 'Log in with Email',
    login_success: 'Login Succeeded',
    login_success_description: 'You have successfully logged into game_name, please return to the game to check',
    login_success_retry: 'If not logged in the game, please {retry_link} or {check_link}.',
    login_success_retry_scheme:
      'If the app did not open, {retry_link}. Still having issues? Try to {refresh_link} or {check_link}.',
    retry_link_text: 'click here to retry',
    retry_open_app_link_text: 'click here to open',
    refresh_page_link_text: 'refresh the page',
    check_browser_link_text: 'Check browser settings',
    browser_help_title: 'How to check browser settings:',
    browser_help_step1: 'Click the button on the left side of the browser address bar;',
    browser_help_step2: 'Find [Local Network Access Permission] and turn it on;',
    browser_help_step3: 'Refresh the current page.',
    browser_help_chrome: 'Chrome Browser',
    browser_help_footer:
      'If the steps above do not resolve the issue, please try setting a different browser as your default browser.',
    login_cancel: 'Login Cancelled',
    login_fail_invalid: 'The current login page is no longer available, please return to game_name to try again',
    enter_your_phone_number: 'Enter your phone number',
    enter_email: 'Enter your email address',
    invalid_phone: 'Please enter a valid mobile phone number',
    invalid_email: 'Please enter a valid email address',
    incorrect_code: 'Please enter the correct verification code',
    log_in: 'Log in',
    verify: 'Verify',
    retry: 'Retry',
    search: 'Search',
    phone_number: 'Phone number',
    email: 'Email',
    send_to: 'Send to',
    enter_the_code: 'Enter the code',
    send_a_code: 'Send a code',
    code_sent: 'A verification code has been sent.',
    fill_verification_code: 'Please enter the verification code',
    user_agreement: 'User Agreement',
    privacy_policy: 'Privacy Policy',
    tracking_id: 'Issue Tracking ID',
    copy: 'Copy',
    copied: 'Copied',
  },
  ja_JP: {
    login_with_phone: '電話番号でログイン',
    login_with_email: 'メールでログイン',
    login_success: 'ログインに成功しました',
    login_success_description: 'game_name へのログインに成功しました。ゲームに戻ってご確認ください。',
    login_success_retry: 'ゲーム内未ログイン？{retry_link}または{check_link}してください。',
    login_success_retry_scheme:
      'アプリが開かない場合は{retry_link}。問題が解決しない場合は{refresh_link}または{check_link}をお試しください。',
    retry_link_text: 'ここをクリックして再試行',
    retry_open_app_link_text: 'こちらをクリックして開く',
    refresh_page_link_text: 'ページを更新',
    check_browser_link_text: 'ブラウザ設定を確認',
    browser_help_title: 'ブラウザ設定の確認方法：',
    browser_help_step1: 'ブラウザのアドレスバーの左側にあるボタンをクリックしてください；',
    browser_help_step2: '【ローカルネットワークアクセス権限】を見つけて、スイッチをオンにしてください；',
    browser_help_step3: '現在のページを更新してください。',
    browser_help_chrome: 'Chrome ブラウザ',
    browser_help_footer: '上記の手順でも解決しない場合は、他のブラウザをデフォルトブラウザに設定してみてください。',
    login_cancel: 'ログインがキャンセルされました',
    login_fail_invalid: 'ログインの有効期限が切れました。 game_name に戻って再度お試しください',
    enter_your_phone_number: '電話番号を入力',
    enter_email: 'メールアドレスを入力',
    invalid_phone: '有効な電話番号を入力してください',
    invalid_email: '有効なメールアドレスを入力してください',
    incorrect_code: '正しい確認コードを入力してください',
    log_in: 'ログイン',
    verify: '確認',
    retry: '再試行',
    search: '検索',
    phone_number: '電話番号',
    email: 'メールアドレス',
    send_to: '送信先',
    enter_the_code: 'コードを入力',
    send_a_code: 'コードを送信',
    code_sent: '確認コードが送信されました',
    fill_verification_code: '確認コードを入力してください',
    user_agreement: '利用規約',
    privacy_policy: 'プライバシーポリシー',
    tracking_id: '問題追跡ID',
    copy: 'コピー',
    copied: 'コピー完了',
  },
  ko_KR: {
    login_with_phone: '전화번호로 로그인',
    login_with_email: '이메일로 로그인하기',
    login_success: '로그인 성공',
    login_success_description: '성공적으로 game_name 에 로그인하였습니다. 게임으로 돌아가 확인하세요.',
    login_success_retry: '게임 내 로그인되지 않음? {retry_link} 또는 {check_link}.',
    login_success_retry_scheme: '앱이 열리지 않으면 {retry_link}. 문제가 계속되면 {refresh_link} 또는 {check_link}.',
    retry_link_text: '여기를 클릭하여 다시 시도',
    retry_open_app_link_text: '여기를 클릭하여 열기',
    refresh_page_link_text: '페이지 새로고침',
    check_browser_link_text: '브라우저 설정 확인',
    browser_help_title: '브라우저 설정 확인 방법:',
    browser_help_step1: '브라우저 주소 표시줄 왼쪽에 있는 버튼을 클릭합니다;',
    browser_help_step2: '[로컬 네트워크 액세스 권한]을 찾아 스위치를 켭니다;',
    browser_help_step3: '현재 페이지를 새로 고침합니다.',
    browser_help_chrome: 'Chrome 브라우저',
    browser_help_footer: '위의 단계로도 해결되지 않으면 다른 브라우저를 기본 브라우저로 설정해 보세요.',
    login_cancel: '로그인이 취소되었습니다',
    login_fail_invalid: '현재 로그인 페이지가 비활성화되었습니다. game_name 에 돌아간 뒤 다시 시도하세요.',
    enter_your_phone_number: '전화번호를 입력하세요',
    enter_email: '이메일 주소를 입력하세요',
    invalid_phone: '유효한 핸드폰 번호를 입력해 주세요',
    invalid_email: '유효한 이메일 주소를 입력해주세요',
    incorrect_code: '정확한 인증 코드를 입력해 주세요',
    log_in: '로그인',
    verify: '확인하기',
    retry: '다시 시도',
    search: '검색',
    phone_number: '휴대폰 번호',
    email: '이메일',
    send_to: '발송하기',
    enter_the_code: '코드를 입력하세요',
    send_a_code: '코드 보내기',
    code_sent: '인증 코드가 전송되었습니다.',
    fill_verification_code: '인증 코드를 입력해 주세요',
    user_agreement: '사용자 계약서',
    privacy_policy: '개인정보 처리방침',
    tracking_id: '문제 추적 ID',
    copy: '복사',
    copied: '복사됨',
  },
  th_TH: {
    login_with_phone: 'เข้าสู่ระบบด้วยหมายเลขโทรศัพท์',
    login_with_email: 'เข้าสู่ระบบด้วยอีเมล',
    login_success: 'ล็อกอินสำเร็จ',
    login_success_description: 'คุณล็อกอิน game_name สำเร็จ กรุณากลับไปที่เกมเพื่อตรวจสอบ',
    login_success_retry: 'ล็อกอินเกมไม่สำเร็จ? กรุณา{retry_link}หรือ{check_link}',
    login_success_retry_scheme: 'หากแอปไม่เปิด กรุณา{retry_link} หากยังมีปัญหา ลอง{refresh_link}หรือ{check_link}',
    retry_link_text: 'คลิกที่นี่เพื่อลองใหม่',
    retry_open_app_link_text: 'คลิกที่นี่เพื่อเปิด',
    refresh_page_link_text: 'รีเฟรชหน้า',
    check_browser_link_text: 'ตรวจสอบการตั้งค่าเบราว์เซอร์',
    browser_help_title: 'วิธีตรวจสอบการตั้งค่าเบราว์เซอร์:',
    browser_help_step1: 'คลิกปุ่มทางด้านซ้ายของแถบที่อยู่เบราว์เซอร์;',
    browser_help_step2: 'ค้นหา [สิทธิ์การเข้าถึงเครือข่าย] และทำการเปิด;',
    browser_help_step3: 'รีเฟรชหน้าปัจจุบัน',
    browser_help_chrome: 'เบราว์เซอร์ Chrome',
    browser_help_footer:
      'หากขั้นตอนข้างต้นยังไม่สามารถแก้ปัญหาได้ กรุณาลองตั้งค่าเบราว์เซอร์อื่นเป็นเบราว์เซอร์เริ่มต้น',
    login_cancel: 'ล็อกอินถูกยกเลิก',
    login_fail_invalid: 'หน้าล็อกอินของปัจจุบันนี้ไม่ถูกต้อง กรุณากลับ game_name เพื่อลองใหม่',
    enter_your_phone_number: 'ป้อนหมายเลขโทรศัพท์ของคุณ',
    enter_email: 'กรอกที่อยู่อีเมล์ของคุณ',
    invalid_phone: 'กรอกข้อมูลที่ถูกต้อง',
    invalid_email: 'กรอกข้อมูลที่ถูกต้อง',
    incorrect_code: 'ข้อมูลผิดพลาด',
    log_in: 'เข้าสู่ระบบ',
    verify: 'ตรวจสอบ',
    retry: 'ลองใหม่',
    search: 'ค้นหา',
    phone_number: 'หมายเลขโทรศัพท์มือถือ',
    email: 'อีเมล',
    send_to: 'ส่งถึง',
    enter_the_code: 'ใส่รหัส',
    send_a_code: 'ส่งรหัส',
    code_sent: 'รหัสยืนยันได้ถูกส่งแล้ว',
    fill_verification_code: 'กรุณากรอกรหัสยืนยัน',
    user_agreement: 'ข้อตกลงการใช้งาน',
    privacy_policy: 'นโยบายความเป็นส่วนตัว',
    tracking_id: 'รหัสติดตามปัญหา',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
  },
  id_ID: {
    login_with_phone: 'Masuk Dengan Nomor Telepon',
    login_with_email: 'Masuk dengan Email',
    login_success: 'Login berhasil',
    login_success_description: 'Anda telah berhasil masuk ke game_name. Harap kembalikan game untuk diperiksa.',
    login_success_retry: 'Anda belum masuk ke game? {retry_link} atau {check_link}.',
    login_success_retry_scheme:
      'Jika aplikasi tidak terbuka, {retry_link}. Masih bermasalah? Coba {refresh_link} atau {check_link}.',
    retry_link_text: 'Klik di sini untuk mencoba lagi',
    retry_open_app_link_text: 'klik di sini untuk membuka',
    refresh_page_link_text: 'segarkan halaman',
    check_browser_link_text: 'periksa pengaturan browser',
    browser_help_title: 'Cara memeriksa pengaturan browser:',
    browser_help_step1: 'Klik tombol di sisi kiri bilah alamat browser;',
    browser_help_step2: 'Temukan [Izin Akses Jaringan Lokal] dan aktifkan sakelar;',
    browser_help_step3: 'Segarkan halaman saat ini.',
    browser_help_chrome: 'Browser Chrome',
    browser_help_footer:
      'Jika langkah-langkah di atas masih belum menyelesaikan masalah, silakan coba tetapkan browser lain sebagai browser default Anda.',
    login_cancel: 'Login dibatalkan',
    login_fail_invalid: 'Halaman login saat ini tidak valid. Harap kembalikan game_name untuk mencoba lagi.',
    enter_your_phone_number: 'Masukkan nomor telepon Anda',
    enter_email: 'Masukkan alamat email Anda',
    invalid_phone: 'Isi informasi yang valid',
    invalid_email: 'Isi informasi yang valid',
    incorrect_code: 'Kesalahan informasi',
    log_in: 'Masuk',
    verify: 'Verifikasi',
    retry: 'Coba Lagi',
    search: 'Temukan',
    phone_number: 'Nomor Ponsel',
    email: 'Email',
    send_to: 'Kirim ke',
    enter_the_code: 'Masukkan kode',
    send_a_code: 'Kirimkan kode',
    code_sent: 'Kode verifikasi telah dikirim.',
    fill_verification_code: 'Silakan isi kode verifikasi',
    user_agreement: 'Perjanjian Pengguna',
    privacy_policy: 'Kebijakan Privasi',
    tracking_id: 'ID Pelacakan Masalah',
    copy: 'Salin',
    copied: 'Tersalin',
  },
  vi_VN: {
    login_with_phone: 'Đăng nhập bằng số điện thoại',
    login_with_email: 'Đăng nhập bằng email',
    login_success: 'Đăng nhập thành công',
    login_success_description: 'Bạn đã đăng nhập game_name thành công, vui lòng quay lại trò chơi để xem',
    login_success_retry: 'Bạn chưa đăng nhập vào game? {retry_link} hoặc {check_link}.',
    login_success_retry_scheme:
      'Nếu ứng dụng không mở, {retry_link}. Vẫn gặp sự cố? Hãy thử {refresh_link} hoặc {check_link}.',
    retry_link_text: 'Nhấp vào đây để thử lại',
    retry_open_app_link_text: 'nhấp vào đây để mở',
    refresh_page_link_text: 'làm mới trang',
    check_browser_link_text: 'kiểm tra cài đặt trình duyệt',
    browser_help_title: 'Cách kiểm tra cài đặt trình duyệt:',
    browser_help_step1: 'Nhấp vào nút ở phía bên trái thanh địa chỉ trình duyệt;',
    browser_help_step2: 'Tìm [Quyền truy cập mạng cục bộ] và bật công tắc;',
    browser_help_step3: 'Làm mới trang hiện tại.',
    browser_help_chrome: 'Trình duyệt Chrome',
    browser_help_footer:
      'Nếu các bước trên vẫn không giải quyết được vấn đề, vui lòng thử đặt trình duyệt khác làm trình duyệt mặc định của bạn.',
    login_cancel: 'Đăng nhập đã bị hủy',
    login_fail_invalid: 'Trang đăng nhập hiện tại không hợp lệ.Vui lòng quay lại game_name để thử lại.',
    enter_your_phone_number: 'Nhập số điện thoại của bạn',
    enter_email: 'Nhập địa chỉ email của bạn',
    invalid_phone: 'điền thông tin hợp lệ',
    invalid_email: 'điền thông tin hợp lệ',
    incorrect_code: 'Thông tin sai',
    log_in: 'Đăng nhập',
    verify: 'Xác minh',
    retry: 'Thử lại',
    search: 'Tìm kiếm',
    phone_number: 'Số điện thoại di động',
    email: 'Email',
    send_to: 'Gửi đến',
    enter_the_code: 'Nhập mã code',
    send_a_code: 'Gửi mã',
    code_sent: 'Mã xác nhận đã được gửi.',
    fill_verification_code: 'Vui lòng điền mã xác minh',
    user_agreement: 'Thỏa thuận người dùng',
    privacy_policy: 'Chính sách bảo mật',
    tracking_id: 'Mã theo dõi sự cố',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
  },
  es_ES: {
    login_with_phone: 'Iniciar sesión con número de teléfono',
    login_with_email: 'Iniciar sesión con correo electrónico',
    login_success: 'Iniciado sesión con éxito',
    login_success_description: 'Has iniciado sesión con éxito en game_name. Vuelve al juego para verificarlo.',
    login_success_retry: 'No has iniciado sesión en el juego? {retry_link} o {check_link}.',
    login_success_retry_scheme:
      'Si la aplicación no se abrió, {retry_link}. ¿Sigue sin funcionar? Intenta {refresh_link} o {check_link}.',
    retry_link_text: 'Haz clic aquí para intentarlo de nuevo',
    retry_open_app_link_text: 'haz clic aquí para abrir',
    refresh_page_link_text: 'actualizar la página',
    check_browser_link_text: 'Comprobar configuración del navegador',
    browser_help_title: 'Cómo comprobar la configuración del navegador:',
    browser_help_step1: 'Haga clic en el botón situado a la izquierda de la barra de direcciones;',
    browser_help_step2: 'Busque [Acceso a la red local] y active el interruptor;',
    browser_help_step3: 'Actualice la página actual.',
    browser_help_chrome: 'Navegador Chrome',
    browser_help_footer:
      'Si los pasos anteriores no resuelven el problema, intente cambiar su navegador predeterminado.',
    login_cancel: 'Inicio de sesión cancelado',
    login_fail_invalid: 'Página de inicio de sesión actual inválida, vuelve a game_name e inténtalo de nuevo',
    enter_your_phone_number: 'Ingresa tu número de teléfono',
    enter_email: 'Ingresa tu dirección de correo electrónico',
    invalid_phone: 'Complete información válida',
    invalid_email: 'Complete información válida',
    incorrect_code: 'Error en la información',
    log_in: 'Iniciar sesión',
    verify: 'Verificar',
    retry: 'Reintentar',
    search: 'Buscar',
    phone_number: 'número de teléfono móvil',
    email: 'Correo electrónico',
    send_to: 'Enviar a',
    enter_the_code: 'Ingresa el código',
    send_a_code: 'Envía un código',
    code_sent: 'Se ha enviado un código de verificación.',
    fill_verification_code: 'Por favor, ingrese el código de verificación',
    user_agreement: 'User Agreement',
    privacy_policy: 'Privacy Policy',
    tracking_id: 'ID de seguimiento',
    copy: 'Copiar',
    copied: 'Copiado',
  },
  pt_PT: {
    login_with_phone: 'Entrar com número de telefone',
    login_with_email: 'Entrar com Email',
    login_success: 'Login com sucesso',
    login_success_description: 'Você fez login com sucesso em game_name. Por favor, volte ao jogo para verificar.',
    login_success_retry: 'Você não está logado no jogo? {retry_link} ou {check_link}.',
    login_success_retry_scheme:
      'Se o aplicativo não abriu, {retry_link}. Ainda com problemas? Tente {refresh_link} ou {check_link}.',
    retry_link_text: 'Clique aqui para tentar novamente',
    retry_open_app_link_text: 'clique aqui para abrir',
    refresh_page_link_text: 'atualizar a página',
    check_browser_link_text: 'verificar configurações do navegador',
    browser_help_title: 'Como verificar as configurações do navegador:',
    browser_help_step1: 'Clique no botão à esquerda da barra de endereços do navegador;',
    browser_help_step2: 'Encontre a opção [Permissão de Acesso à Rede Local] e ative-a;',
    browser_help_step3: 'Atualize a página atual.',
    browser_help_chrome: 'Navegador Chrome',
    browser_help_footer:
      'Se as etapas acima ainda não resolverem o problema, tente definir outro navegador como seu navegador padrão.',
    login_cancel: 'Login cancelado',
    login_fail_invalid: 'A interface de login atual é inválida. Retorne game_name e tente novamente',
    enter_your_phone_number: 'Insira o seu número de telefone',
    enter_email: 'Digite seu endereço de email',
    invalid_phone: 'Preencha informações válidas',
    invalid_email: 'Preencha informações válidas',
    incorrect_code: 'Erro nas informações',
    log_in: 'Entrar',
    verify: 'Verificar',
    retry: 'Tentar novamente',
    search: 'Pesquisar',
    phone_number: 'Número de celular',
    email: 'E-mail',
    send_to: 'Enviar para',
    enter_the_code: 'Insira o código',
    send_a_code: 'Envie um código',
    code_sent: 'Um código de verificação foi enviado.',
    fill_verification_code: 'Por favor, preencha o código de verificação',
    user_agreement: "Contrat d'utilisateur",
    privacy_policy: 'Politique de Confidentialité',
    tracking_id: 'ID de rastreamento',
    copy: 'Copiar',
    copied: 'Copiado',
  },
  fr: {
    login_with_phone: 'Se connecter avec un numéro de téléphone',
    login_with_email: "Se connecter avec l'email",
    login_success: 'Connexion réussie',
    login_success_description:
      'Vous vous êtes connecté avec succès à game_name, veuillez retourner au jeu pour vérifier.',
    login_success_retry: "Vous n'êtes pas connecté au jeu? {retry_link} ou {check_link}.",
    login_success_retry_scheme:
      "Si l'application ne s'est pas ouverte, {retry_link}. Le problème persiste ? Essayez de {refresh_link} ou {check_link}.",
    retry_link_text: 'Cliquez ici pour réessayer',
    retry_open_app_link_text: 'cliquez ici pour ouvrir',
    refresh_page_link_text: 'actualiser la page',
    check_browser_link_text: 'vérifier les paramètres du navigateur',
    browser_help_title: 'Comment vérifier les paramètres du navigateur:',
    browser_help_step1: "Cliquez sur le bouton à gauche de la barre d'adresse du navigateur;",
    browser_help_step2: "Trouvez [Accès au réseau local] et activez l'option;",
    browser_help_step3: 'Actualisez la page actuelle.',
    browser_help_chrome: 'Navigateur Chrome',
    browser_help_footer:
      'Si le problème persiste après ces étapes, essayez de définir un autre navigateur comme navigateur par défaut.',
    login_cancel: 'Connexion annulée',
    login_fail_invalid:
      "La page de connexion actuelle n'est plus disponible, veuillez retourner à game_name pour réessayer.",
    enter_your_phone_number: 'Entrez votre numéro de téléphone',
    enter_email: 'Saisissez votre adresse e-mail',
    invalid_phone: 'Remplissez des informations valides',
    invalid_email: 'Remplissez des informations valides',
    incorrect_code: "Erreur d'information",
    log_in: 'Connexion',
    verify: 'Vérifier',
    retry: 'Réessayer',
    search: 'Recherche',
    phone_number: 'Numéro de téléphone mobile',
    email: 'E-mail',
    send_to: 'Envoyer à',
    enter_the_code: 'Entrez le code',
    send_a_code: 'Envoyer un code',
    code_sent: 'Un code de vérification a été envoyé.',
    fill_verification_code: 'Veuillez remplir le code de vérification',
    user_agreement: "Contrat d'utilisateur",
    privacy_policy: 'Politique de Confidentialité',
    tracking_id: 'ID de suivi',
    copy: 'Copier',
    copied: 'Copié',
  },
  de: {
    login_with_phone: 'Mit Telefonnummer anmelden',
    login_with_email: 'Mit E-Mail anmelden',
    login_success: 'Login erfolgreich',
    login_success_description: 'Du hast dich erfolgreich in game_name eingeloggt, bitte zum Spiel zurückkehren.',
    login_success_retry: 'Du bist nicht in das Spiel eingeloggt? {retry_link} oder {check_link}.',
    login_success_retry_scheme:
      'Wenn die App nicht geöffnet wurde, {retry_link}. Problem besteht weiterhin? Versuche {refresh_link} oder {check_link}.',
    retry_link_text: 'Klicke hier, um es erneut zu versuchen',
    retry_open_app_link_text: 'hier klicken zum Öffnen',
    refresh_page_link_text: 'Seite aktualisieren',
    check_browser_link_text: 'Browsereinstellungen überprüfen',
    browser_help_title: 'Wie man die Browsereinstellungen überprüft:',
    browser_help_step1: 'Klicke auf die Schaltfläche links neben der Adressleiste des Browsers;',
    browser_help_step2: 'Finde [Berechtigung für lokalen Netzwerkzugriff] und schalte den Schalter ein;',
    browser_help_step3: 'Aktualisiere die aktuelle Seite.',
    browser_help_chrome: 'Chrome-Browser',
    browser_help_footer:
      'Wenn die obigen Schritte das Problem nicht lösen, versuche bitte, einen anderen Browser als Standardbrowser festzulegen.',
    login_cancel: 'Login abgebrochen',
    login_fail_invalid:
      'Die aktuelle Login-Seite ist nicht mehr verfügbar. Bitte kehre zu game_name zurück und versuch es erneut',
    enter_your_phone_number: 'Gib deine Telefonnummer ein',
    enter_email: 'Geben Sie Ihre E-Mail-Adresse ein',
    invalid_phone: 'Geben Sie gültige Informationen ein',
    invalid_email: 'Geben Sie gültige Informationen ein',
    incorrect_code: 'Fehlerhafte Informationen',
    log_in: 'Einloggen',
    verify: 'Überprüfen',
    retry: 'Wiederholen',
    search: 'Suche',
    phone_number: 'Handynummer',
    email: 'E-Mail',
    send_to: 'Senden an',
    enter_the_code: 'Gib den Code ein',
    send_a_code: 'Sende einen Code',
    code_sent: 'Ein Verifizierungscode wurde gesendet.',
    fill_verification_code: 'Bitte geben Sie den Bestätigungscode ein',
    user_agreement: 'Nutzervereinbarung',
    privacy_policy: 'Datenschutzrichtlinie',
    tracking_id: 'Fehlerverfolgung-ID',
    copy: 'Kopieren',
    copied: 'Kopiert',
  },
  tr: {
    login_with_phone: 'Telefon Numarası ile Giriş Yap',
    login_with_email: 'E-posta ile Giriş Yap',
    login_success: 'Giriş Yapıldı',
    login_success_description: 'Giriş yaptınız game_name, Oyuna dönüp inceleyiniz',
    login_success_retry: 'Oyunda giriş yapmadınız mı? {retry_link} veya {check_link}.',
    login_success_retry_scheme:
      'Uygulama açılmadıysa {retry_link}. Sorun devam ediyorsa {refresh_link} veya {check_link} deneyin.',
    retry_link_text: 'Tekrar denemek için buraya tıklayın',
    retry_open_app_link_text: 'açmak için buraya tıklayın',
    refresh_page_link_text: 'sayfayı yenileyin',
    check_browser_link_text: 'tarayıcı ayarlarını kontrol edin',
    browser_help_title: 'Tarayıcı ayarları nasıl kontrol edilir:',
    browser_help_step1: 'Tarayıcı adres çubuğunun sol tarafındaki düğmeye tıklayın;',
    browser_help_step2: '[Yerel Ağ Erişim İzni] bulun ve anahtarı açın;',
    browser_help_step3: 'Geçerli sayfayı yenileyin.',
    browser_help_chrome: 'Chrome Tarayıcı',
    browser_help_footer:
      'Yukarıdaki adımlar sorunu çözmezse, lütfen başka bir tarayıcıyı varsayılan tarayıcı olarak ayarlamayı deneyin.',
    login_cancel: 'Giriş Başarısız',
    login_fail_invalid:
      'Mevcut giriş sayfası artık kullanılamıyor, lütfen game_name oyununa geri dönün ve tekrar deneyin.',
    enter_your_phone_number: 'Telefon numaranızı girin',
    enter_email: 'E-posta adresinizi girin',
    invalid_phone: 'Geçerli bilgi girin',
    invalid_email: 'Geçerli bilgi girin',
    incorrect_code: 'Hatalı bilgi',
    log_in: 'Oturum aç',
    verify: 'Doğrula',
    retry: 'Tekrar Dene',
    search: 'Arama',
    phone_number: 'Cep Telefonu Numarası',
    email: 'E-posta',
    send_to: 'Gönder:',
    enter_the_code: 'Kodu girin',
    send_a_code: 'Bir kod gönder',
    code_sent: 'Bir doğrulama kodu gönderildi.',
    fill_verification_code: 'Lütfen doğrulama kodunu girin',
    user_agreement: 'Kullanıcı Sözleşmesi',
    privacy_policy: 'Gizlilik Politikası',
    tracking_id: 'Sorun Takip ID',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
  },
  ru: {
    login_with_phone: 'Войти с номером телефона',
    login_with_email: 'Войти с помощью электронной почты',
    login_success: 'Вход успешен',
    login_success_description: 'Вы успешно вошли в игру game_name, вернитесь в игру, чтобы просмотреть',
    login_success_retry: 'Вы не вошли в игру? {retry_link} или {check_link}.',
    login_success_retry_scheme:
      'Если приложение не открылось, {retry_link}. Проблема не решена? Попробуйте {refresh_link} или {check_link}.',
    retry_link_text: 'Нажмите здесь, чтобы повторить попытку',
    retry_open_app_link_text: 'нажмите здесь, чтобы открыть',
    refresh_page_link_text: 'обновить страницу',
    check_browser_link_text: 'проверьте настройки браузера',
    browser_help_title: 'Как проверить настройки браузера:',
    browser_help_step1: 'Нажмите кнопку в левой части адресной строки браузера;',
    browser_help_step2: 'Найдите [Разрешение доступа к локальной сети] и включите переключатель;',
    browser_help_step3: 'Обновите текущую страницу.',
    browser_help_chrome: 'Браузер Chrome',
    browser_help_footer:
      'Если указанные выше шаги не решают проблему, попробуйте установить другой браузер в качестве браузера по умолчанию.',
    login_cancel: 'Вход не удался',
    login_fail_invalid: 'Текущая страница входа уже недействительна, вернитесь в игру game_name и попробуйте снова',
    enter_your_phone_number: 'Введите ваш номер телефона',
    enter_email: 'Введите свой адрес электронной почты',
    invalid_phone: 'Заполните действительную информацию',
    invalid_email: 'Заполните действительную информацию',
    incorrect_code: 'Ошибка информации',
    log_in: 'Вход в систему',
    verify: 'Проверить',
    retry: 'Повторить',
    search: 'Поиск',
    phone_number: 'Номер мобильного телефона',
    email: 'Электронная почта',
    send_to: 'Отправить в',
    enter_the_code: 'Введите код',
    send_a_code: 'Отправьте код',
    code_sent: 'Код подтверждения был отправлен.',
    fill_verification_code: 'Пожалуйста, введите код подтверждения',
    user_agreement: 'Пользовательское Соглашение',
    privacy_policy: 'Политика конфиденциальности',
    tracking_id: 'ID отслеживания',
    copy: 'Копировать',
    copied: 'Скопировано',
  },
};

// 语言别名映射关系（用于支持多种 region code 格式）
const LANG_ALIAS_MAP = {
  in_ID: 'id_ID', // 印尼语别名
  fr_FR: 'fr', // 法语
  de_DE: 'de', // 德语
  tr_TR: 'tr', // 土耳其语
  ru_RU: 'ru', // 俄语
};

/**
 * 构建完整的语言映射表
 * 在初始化时展开别名，确保所有别名都指向同一个对象引用（节省内存）
 */
const buildLangMap = () => {
  const map = { ...BASE_LANG_DATA };

  // 添加别名引用（共享同一个对象）
  Object.keys(LANG_ALIAS_MAP).forEach((alias) => {
    const target = LANG_ALIAS_MAP[alias];
    map[alias] = map[target];
  });

  return map;
};

// 导出完整的 LANG_MAP（向后兼容）
export const LANG_MAP = buildLangMap();

/**
 * 获取指定语言的数据（可选的工具函数）
 * @param {string} langRegion - 语言区域代码（如 'zh_CN', 'en_US', 'in_ID' 等）
 * @param {string} fallback - 回退语言，默认为 'en_US'
 * @returns {Object} 语言数据对象
 */
export const getLangData = (langRegion, fallback = 'en_US') => {
  const normalized = LANG_ALIAS_MAP[langRegion] || langRegion;
  return BASE_LANG_DATA[normalized] || BASE_LANG_DATA[fallback];
};
